<template>
  <div class="userDetail">
    <UserFieldEditDialog ref="fieldDialog" @confirm="onFieldEditConfirm" />
    <div class="Con">
      <nav>{{ $fanyi("基本信息") }}</nav>
      <div class="ConOpt">
        <label>{{ $fanyi("姓氏") }}：</label>
        <!--        <input-->
        <!--            class="istrueInput"-->
        <!--            autocomplete="new-password"-->
        <!--            v-model="userDatas.user_last_name"-->
        <!--            :placeholder="$fanyi('请输入姓氏')"-->
        <!--        />-->
        <!--      <div class="gou">✔</div>-->
        <div class="userMessage">
          <el-input
            class="uiInput"
            v-model="userDatas.user_last_name"
            disabled
          />
          <button @click="changeUserName('last_name')">
            {{ $fanyi("修改") }}
          </button>
        </div>
      </div>
      <div class="ConOpt">
        <label>{{ $fanyi("名字") }}：</label>
        <div class="userMessage">
          <el-input class="uiInput" v-model="userDatas.user_name" disabled />
          <button @click="changeUserName('name')">{{ $fanyi("修改") }}</button>
        </div>
      </div>
      <div class="ConOpt">
        <label>{{ $fanyi("NIF / DNI") }}：</label>
        <div class="userMessage">
          <el-input
            class="uiInput"
            v-model="userDatas.user_id_card"
            disabled
            :type="showNIF ? 'text' : 'password'"
          />
          <button @click="changeUserName('NIF')">
            {{ $fanyi("修改") }}
          </button>
        </div>
      </div>
      <div class="ConOpt">
        <label>{{ $fanyi("电子邮件") }}：</label>
        <div class="userMessage">
          <el-input class="uiInput" v-model="userDatas.email" disabled />
          <button
            @click="$fun.routerToPage('/user/changepassworld?type=email')"
          >
            {{ $fanyi("修改") }}
          </button>
        </div>
      </div>
      <div class="ConOpt">
        <label>{{ $fanyi("手机") }}：</label>
        <div class="userMessage">
          <el-input class="uiInput" v-model="userDatas.mobile" disabled />
          <button
            @click="$fun.routerToPage('/user/changepassworld?type=mobile')"
          >
            {{ $fanyi("修改") }}
          </button>
        </div>
      </div>
      <!-- <el-button type="primary">保存</el-button> -->
    </div>
  </div>
</template>
<script>
import UserFieldEditDialog from "./components/UserFieldEditDialog.vue";

export default {
  data() {
    return {
      userDatas: {},
      showNIF: true, //显示身份证
      showpassword: false, //显示密码
      mark: "",
      markList: [],
    };
  },
  components: { UserFieldEditDialog },
  computed: {},
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.EuropegetUserInfo().then((res) => {
        if (res.code != 0) return this.message.error(res.msg);
        this.userDatas = res.data;
      });
    },

    // 修改用户名
    changeUserName(type) {
      if (type === "name") {
        this.$refs.fieldDialog.open("name", this.userDatas.user_name);
      } else if (type === "last_name") {
        this.$refs.fieldDialog.open("last_name", this.userDatas.user_last_name);
      } else if (type === "NIF") {
        this.$refs.fieldDialog.open("NIF", this.userDatas.user_id_card, {
          type: this.showNIF ? "text" : "password",
        });
      }
    },

    onFieldEditConfirm({ field, value }) {
      if (field === "name") {
        this.$api.userUserNameSave({ user_name: value }).then((res) => {
          if (res.code != 0) return;
          this.getData();
        });
      } else if (field === "last_name") {
        this.$api
          .userUserLastNameSave({ user_last_name: value })
          .then((res) => {
            if (res.code != 0) return;
            this.getData();
          });
      } else if (field === "NIF") {
        this.$api.userUserIdCardSave({ user_id_card: value }).then((res) => {
          if (res.code != 0) return;
          this.getData();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../../../css/mixin.scss";
.userDetail {
  // height: 392px;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  padding-bottom: 40px 60px;
  background-color: #fff;
  nav {
    padding-bottom: 30px;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
    line-height: 24px;
  }
  .Con {
    padding: 50px 0 0 60px;

    .ConOpt {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      .userMessage {
        position: relative;
        display: flex;
        align-items: center;
        .uiInput {
          width: 400px;
        }
        /deep/ .uiInput .el-input__inner {
          height: 40px;
          line-height: 40px;
          background-color: #fff;
          color: #000;
        }
      }
      label {
        display: inline-block;
        text-align: left;
        font-size: 14px;
        color: #000000;
        line-height: 19px;
        margin-bottom: 10px;
      }
      button {
        width: 30px;
        height: 19px;
        font-size: 14px;
        margin-left: 24px;
        color: $homePageSubjectColor;
        line-height: 19px;
        background-color: transparent;
        user-select: none;
      }
    }
    .el-icon-view {
      position: absolute;
      left: 380px;
      top: 5px;
    }
    .el-button {
      width: 96px;
      height: 40px;
      background: #009246;
      border-radius: 4px;
      margin-top: 10px;
      margin-left: 135px;
      font-size: 16px;
      color: #ffffff;
      line-height: 18px;
    }
  }
}
</style>
